import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { SectionTitle } from './styled'

const HelpSection = props => {
  const { titleId, children } = props

  return (
    <section>
      <SectionTitle level={3}>
        <FormattedMessage id={titleId} />
      </SectionTitle>
      {children}
    </section>
  )
}
HelpSection.propTypes = {
  titleId: PropTypes.string.isRequired
}
export default HelpSection
